<template>
  <div>
    <h2>Listes</h2>
    <div class="display">
      <div class="header">
        <ul>
          <li class="name"><a href="#">Nom <i class="fas fa-chevron-down"></i></a></li>
          <li class="desc"><a href="#">Description</a></li>
          <li class="date"><a href="#">Date de création <i class="fas fa-chevron-down"></i></a></li>
          <li class="public"><a href="#">Publique <i class="fas fa-chevron-down"></i></a></li>
        </ul>
      </div>
      <div class="liste">
        <ul>
          <li v-for="liste in listes" :key="liste.id">
            <div>
              <p class="name">{{ liste.nom }}</p><!--
              --><p class="desc">{{ liste.description }}</p><!--
              --><p class="date">{{ liste.date }}</p><!--
              --><p class="public"><toggle-button @change="updatePublic(liste.nom, liste.public)" :value="liste.public === 1"/></p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="add">
      <form action="" @submit.prevent="send()" @reset="reset()">
        <ul>
          <li><input v-model="newListe.nom" type="text" placeholder="Nom de la liste"></li>
          <li><input v-model="newListe.desc" type="text" placeholder="Description"></li>
          <li><button type="submit">Ajouter</button></li>
          <li><button type="reset">Annuler</button></li>
        </ul>
      </form>
    </div>
  </div>
</template>

<script>
import {settings} from '../../assets/settings'

export default {
  name: 'Listes',
  data () {
    return {
      listes: [],
      newListe: {
        nom: '',
        desc: ''
      }
    }
  },
  methods: {
    getListes () {
      this.$http.get(settings.apiUrl + '/list/' + this.$parent.store.getToken()).then((response) => {
        this.listes = response.body.payload
      })
    },
    updatePublic (listeName) {
      let data = {
        public: true
      }
      this.$http.put(settings.apiUrl + '/list/' + listeName + '/' + this.$parent.store.getToken(), {data: JSON.stringify(data)}).then((response) => {
        if (response.body.success === false) {
          alert('error')
        } else {
          this.getListes()
        }
      })
    },
    send () {
      let error = ''
      if (this.newListe.nom.length <= 5) {
        error += '\nEntrer un nom de plus de 5 caractères.'
      }
      if (this.newListe.desc.length <= 10) {
        error += '\nEntrer une description de plus de 10 caractères.'
      }
      if (error !== '') {
        alert(error)
      } else {
        this.$http.post(settings.apiUrl + '/list/' + this.$parent.store.getToken(), {data: JSON.stringify(this.newListe)}).then((response) => {
          if (response.body.success === false) {
            alert('error')
          } else {
            this.reset()
            this.getListes()
          }
        })
      }
    },
    reset () {
      this.newListe = {
        nom: '',
        description: ''
      }
    }
  },
  mounted () {
    this.getListes()
  }
}
</script>

<style scoped lang="scss">
  .display {
    width: calc(100% - 30px);
    background-color: #fff;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    height: calc(100vh - 270px);
    padding: 15px;
    overflow-y: scroll;
    .header {
      display:block;
      width: 100%;
      ul {
        display: flex;
        list-style-type: none;
        border-bottom: 1px solid #aaaaaa;
        padding-bottom: 10px;
        li {
          a {
            text-decoration: none;
            color: #777777;
          }
        }
        .name {
          width: 20%;
        }
        .desc {
          width: 40%;
          cursor: text;
        }
        .date {
          width: 25%;
        }
        .public {
          width: 15%;
        }
      }
    }
    .liste {
      ul {
        list-style-type: none;
        li {
          div {
            padding: 10px 0;
            p {
              display: inline-block;
            }
            .name {
              width: 20%;
            }
            .desc {
              width: 40%;
            }
            .date {
              width: 25%;
            }
            .public {
              width: 15%;
            }
          }
        }
      }
    }
  }
  .add {
    padding: 10px;
    background-color: #fff;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    margin-top: 20px;
    ul {
      list-style-type: none;
      display: flex;
      justify-content: space-between;
      li {
        input, button {
          width: calc(100% - 20px);
          border: none;
          background-color: #e5e5e5;
          font-size: 20px;
          padding: 10px;
          border-radius: 4px;
          font-family: 'Roboto', sans-serif;
        }
        button {
          width: 100%;
          cursor: pointer;
        }
        button[type="submit"] {
          background-color: #175676;
          color: #fff;
        }
        button[type="reset"] {
          background-color: rgba(23, 86, 118, 0.2);
          color: #000;
        }
      }
      li:nth-child(1) {
        width: 30%;
      }
      li:nth-child(2) {
        width: 40%;
      }
      li:nth-child(3) {
        width: 17%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Page/Listes.vue